import React, { useContext, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../helpers/components/KTSVG";
import { useChatFilters } from "../../../utils/hooks/useChatFilters";
import { useSearchParams } from "react-router-dom";
import { Dropdown } from "../../../helpers/components/Dropdown";
import ChatContext from "../../../context/ChatContext";
import { createInitials } from "../../../utils/functions/createInitials";
import { IChatbotState } from "../../../utils/interfaces/IChatbotState";
import { useQuery } from "@apollo/client";
import {
  GET_CHAT_ROOMS,
  GET_ALL_APPLICATION_IDS,
} from "../../../graphql/query";
import { MultiSelect } from "react-multi-select-component";
import SkeletonChatHistory from "./SkeletonChatHistory";

import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";

interface IProps {
  type: "Unassigned" | "Assigned" | "Resolved";
  chatRoomID: any;
  updateApplicationIds: (ids: number[]) => void;
}

const ResolvedLeftPanel: React.FC<IProps> = ({
  type,
  chatRoomID,
  updateApplicationIds,
}) => {
  const { state, setState } = useContext(ChatContext);

  console.log(state, "state21212112");

  const { operations, models } = useChatFilters();
  const [, setSearchParams] = useSearchParams();
  const filterDropdownMenuRef = useRef<HTMLDivElement>(null);
  const [filterMenuDroppedDown, setFilterMenuDroppedDown] =
    useState<boolean>(false);
  const [updateChatRoomsFlag, setUpdateChatRoomsFlag] =
    useState<boolean>(false);
  const [isLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const chatRoomsArrayRef = useRef<any[]>([]);
  const didComponentMountRef = useRef<boolean>(false);
  const chatRoomsPerPage = 10;
  const initialAllApplicationIdsSelected: any = [];
  const [applicationIdSelected, setApplicationIdSelected] = useState<any>(
    initialAllApplicationIdsSelected
  );

  const [options] = useState<any>([]);
  const [isFilterSet, setIsFilterSet] = useState<boolean>(false);
  const {
    loading: loading1,
    error: error1,
    data: data1,
    refetch: refetchChatRooms,
    // networkStatus,
  } = useQuery(GET_CHAT_ROOMS, {
    variables: {
      input: {},
    },
    context: {
      headers: {
        "access-control-allow-methods": "Chat-history",
      },
    },
  });

  const {
    loading: loading2,
    error: error2,
    data: data2,
  } = useQuery(GET_ALL_APPLICATION_IDS, {
    variables: {
      input: {
        appIDString: null,
      },
    },
    context: {
      headers: {
        "access-control-allow-methods": "Chat-history",
      },
    },
  });

  useEffect(() => {
    if (updateChatRoomsFlag === true) {
      const chatRoomsArray = chatRoomsArrayRef.current;
      console.log("useEffect called to update Chat Rooms array !");
      setState(
        (prevState: IChatbotState) => ({
          ...prevState,
          chatRooms: chatRoomsArray,
        }),
        (updatedState: IChatbotState) => {
          if (didComponentMountRef.current === false) {
            didComponentMountRef.current = true;
          }
        }
      );
      return () => {
        setUpdateChatRoomsFlag(false);
      };
    }
  });

  useEffect(() => {
    let selectedApplications: number[] = applicationIdSelected.map((app: any) =>
      Number(app.value)
    );
    updateApplicationIds(selectedApplications); // Update parent state when selection changes
  }, [applicationIdSelected]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  useEffect(() => {
    if (error1) {
      // Check if specific error message "No chat rooms found"
      const noChatRoomsError = error1.graphQLErrors?.find(
        (err) => err.message === "No chat rooms found"
      );
      if (noChatRoomsError) {
        toast.error(noChatRoomsError.message);
   
        setState((prevState: IChatbotState) => ({
          ...prevState,
          chatRooms: [],
        }));
        return; 
      } else {
        toast.error("Error loading chat rooms");
      }
    }
  }, [data1, error1]);

  useEffect(() => {
    if (!!data1) {
      if (type === "Resolved") {
        const chatRooms = data1?.chatRooms?.data?.data;
        const newChatRoomsArray = chatRooms
          ?.map((chatRoom: any) => {
            let initials;
            if (chatRoom.chatRoomMeta && chatRoom.chatRoomMeta.length > 0) {
              const metaName = chatRoom?.chatRoomMeta?.find((metaData: any) =>
                metaData?.name?.toLowerCase().includes("name")
              );
              if (metaName) {
                initials = createInitials(metaName.value);
              }
            } else if (chatRoom.id) {
              initials = createInitials(
                data2?.allApplicationId?.find(
                  (app: any) =>
                    parseInt(app.id) === chatRoom?.chatName?.applicationId
                )?.appName
              );
            } else {
              initials = createInitials("");
            }

            return {
              ...chatRoom,
              initials,
            };
          })
          .sort((a: any, b: any) => {
            // Sort by putting last chatRoomID in first
            return parseInt(b.id) - parseInt(a.id);
          });

        chatRoomsArrayRef.current = newChatRoomsArray;
        setUpdateChatRoomsFlag(true);
        console.log("Set to call useEffect to update chatRooms");
      }
    }
  }, [data1]);

  if (!!data2 && data2?.allApplicationId?.length > 0) {
    data2?.allApplicationId?.forEach((allApplicationId: any, index: any) => {
      initialAllApplicationIdsSelected.push({
        label: allApplicationId.appName,
        value: allApplicationId.id,
      });
    });
  }

  useEffect(() => {
    if (data2?.allApplicationId?.length > 0) {
      if (applicationIdSelected.length === 0) {
        setApplicationIdSelected([
          {
            label: data2?.allApplicationId[0]?.appName,
            value: data2?.allApplicationId[0]?.id,
          },
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationIdSelected, data2]);

  useEffect(() => {
    setIsFilterSet(true);
    let selectedapplications: number[] = [];
    if (!!data2) {
      if (type === "Resolved") {
        applicationIdSelected.forEach((theapplicationId: any) =>
          selectedapplications.push(Number(theapplicationId.value))
        );
        if (!!data2 && data2?.allApplicationId?.length > 0) {
          data2?.allApplicationId.forEach(
            (allApplicationId: any, index: any) => {
              let present = options.some(
                (code: { label: string }) =>
                  code.label === allApplicationId.appName
              );
              if (!present) {
                options.push({
                  label: allApplicationId.appName,
                  value: allApplicationId.id,
                });
              }
            }
          );
        }

        operations.updateChatFilters(
          "applicationIds",
          selectedapplications,
          (updatedChatfilters) => {
            if (!!updatedChatfilters.applicationIds) {
              refetchChatRooms({
                input: {
                  applicationIds: updatedChatfilters.applicationIds,
                  limit: chatRoomsPerPage,
                  offset: (currentPage - 1) * chatRoomsPerPage,
                },
              });
            } else {
              setIsFilterSet(false);
              refetchChatRooms({
                input: {
                  applicationIds: [],
                  limit: chatRoomsPerPage,
                  offset: (currentPage - 1) * chatRoomsPerPage,
                },
              });
            }
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data2, applicationIdSelected]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("chatRoomId")) {
      params.delete("chatRoomId");
      setSearchParams(Object.fromEntries(params.entries()));
    }
  }, []);

  useEffect(() => {
    if (isFilterSet) {
      refetchChatRooms({
        input: {
          ...models.chatFilters,
          limit: chatRoomsPerPage,
          offset: (currentPage - 1) * chatRoomsPerPage,
        },
      });
    } else {
      refetchChatRooms({
        input: {
          limit: chatRoomsPerPage,
          offset: (currentPage - 1) * chatRoomsPerPage,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  // Pagination
  const totalChatrooms =
    !error1 && data1?.chatRooms?.data?.count ? data1.chatRooms.data.count : 0;

  const totalPages =
    chatRoomsPerPage > 0 ? Math.ceil(totalChatrooms / chatRoomsPerPage) : 0;
  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    const params = new URLSearchParams(window.location.search);
    if (params.has("chatRoomId")) {
      params.delete("chatRoomId");
      setSearchParams(Object.fromEntries(params.entries()));
    }
  };

  const nextPage = () => {
    if (totalPages > 0 && currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
      const params = new URLSearchParams(window.location.search);
      if (params.has("chatRoomId")) {
        params.delete("chatRoomId");
        setSearchParams(Object.fromEntries(params.entries()));
      }
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      const params = new URLSearchParams(window.location.search);
      if (params.has("chatRoomId")) {
        params.delete("chatRoomId");
        setSearchParams(Object.fromEntries(params.entries()));
      }
    }
  };

  // Generate snake handle pagination numbers
  const paginationNumbers = () => {
    const numbers = [];
    const maxVisibleNumbers = 4; // Maximum visible pagination numbers

    if (totalPages <= maxVisibleNumbers) {
      // If total pages are less than or equal to max visible numbers, show all
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i);
      }
    } else {
      const middleIndex = Math.ceil(maxVisibleNumbers / 2); // Middle index of the pagination numbers
      let startPage = currentPage - middleIndex + 1;
      let endPage = currentPage + middleIndex - 1;

      if (startPage < 1) {
        // If start page is less than 1, adjust start and end page accordingly
        endPage = startPage + maxVisibleNumbers - 1;
        startPage = 1;
      } else if (endPage > totalPages) {
        // If end page is greater than total pages, adjust start and end page accordingly
        startPage = endPage - maxVisibleNumbers + 1;
        endPage = totalPages;
      }

      for (let i = startPage; i <= endPage; i++) {
        numbers.push(i);
      }
    }

    return numbers;
  };

  if (isLoading || loading1 || loading2) return <SkeletonChatHistory />;
  if (error2) return <h1>{error2.message}</h1>;
  if (!!isLoading) {
    return (
      <>
        <SkeletonChatHistory />
      </>
    );
  }

  const formatEndDate = (endDateStr: string | number | Date) => {
    if (!endDateStr) return null;

    const endDate = new Date(endDateStr);
    const today = new Date();

    // Function to check if the date is today
    const isToday = (someDate: Date) => {
      return (
        someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear()
      );
    };

    if (isToday(endDate)) {
      return endDate.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    } else {
      const day = String(endDate.getDate()).padStart(2, "0");
      const month = String(endDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
      const year = String(endDate.getFullYear()).slice(-2); // Get the last two digits of the year
      return `${day}/${month}/${year}`;
    }
  };

  const handleFilter = (e: React.FormEvent<HTMLFormElement>) => {
    // Handle filter / search graphql API call
    setIsFilterSet(true);
    e.preventDefault();
    refetchChatRooms({
      input: {
        ...models.chatFilters,
        limit: chatRoomsPerPage,
        offset: (currentPage - 1) * chatRoomsPerPage,
      },
    });
    if (filterMenuDroppedDown === true) {
      setFilterMenuDroppedDown(false);
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsFilterSet(true);
    operations.updateChatFilters(
      "query",
      e.target.value,
      (updatedChatfilters: any) => {
        if (!!updatedChatfilters.query) {
          refetchChatRooms({
            input: {
              ...models.chatFilters,
              query: parseInt(updatedChatfilters.query),
              limit: chatRoomsPerPage,
              offset: (currentPage - 1) * chatRoomsPerPage,
            },
          });
        } else {
          setIsFilterSet(true);
          refetchChatRooms({
            input: {
              ...models.chatFilters,
              query: null,
              limit: chatRoomsPerPage,
              offset: (currentPage - 1) * chatRoomsPerPage,
            },
          });
        }
      }
    );
  };

  const handleChatRoomClick = (chatRoom: any) => {
    console.log(chatRoom);
    setSearchParams({ type: type, chatRoomId: chatRoom.id });
    setState((prevState: IChatbotState) => {
      const existingPanel = prevState.panelBasedConversation.find(
        (panel) => panel.chatRoomId === chatRoom.id
      );

      if (!existingPanel) {
        return {
          ...prevState,
          panelBasedConversation: [
            ...prevState.panelBasedConversation,
            {
              chatRoomId: parseInt(chatRoom.id),
              conversation: [],
            },
          ],
        };
      }
      return prevState;
    });
  };

  const getDisplayName = (chatRoom: any) => {
    if (!!chatRoom.chatRoomMeta && chatRoom.chatRoomMeta.length > 0) {
      const metaName = chatRoom?.chatRoomMeta?.find((metaData: any) =>
        metaData?.name?.toLowerCase().includes("name")
      );
      return metaName?.value;
    } else if (!!chatRoom?.id) {
      return chatRoom?.id;
    }

    return "Unnamed";
  };

  const getAgentName = (chatRoom: any) => {
    if (chatRoom?.chatName?.agentId !== null) {
      return chatRoom?.chatName?.agentId;
    } else if (chatRoom?.assignedAgentId) {
      return chatRoom?.assignedAgentId;
    } else {
      return;
    }
  };
  const isPrevDisabled = currentPage === 1 ? "disabled" : "";
  const isNextDisabled = currentPage === totalPages ? "disabled" : "";

  return (
    <div
      className="card card-flush"
      style={{ boxShadow: "0 2px 8px 0 #00000029" }}
    >
      <div
        className="card-header pt-7 flex-nowrap flex-column"
        id="kt_chat_contacts_header"
      >
        <div className="d-flex">
          <div className="col">
            <span className="fw-bolder text-dark align-items-center fs-4 fs-md-6">
              Filter Chatroom By Application ID:
            </span>
            <div className="d-flex justify-content-between">
              <div className="mb-4 mt-3 flex-grow-1">
                <div style={{ position: "relative" }}>
                  <MultiSelect
                    options={options}
                    value={applicationIdSelected}
                    onChange={setApplicationIdSelected}
                    labelledBy="Select Application"
                    hasSelectAll={true}
                    overrideStrings={{
                      selectSomeItems: "Select applications...",
                      allItemsAreSelected: "All applications selected",
                      selectAll: "Select All",
                      search: "Search applications...",
                    }}
                  />
                </div>
              </div>
              <div
                className="d-flex align-items-center ms-3"
                ref={filterDropdownMenuRef}
              >
                <div
                  className="btn btn-sm btn-icon btn-light"
                  onClick={() =>
                    setFilterMenuDroppedDown(!filterMenuDroppedDown)
                  }
                  style={{ height: "3.3rem" }}
                >
                  <img
                    src="/media/icons/duotune/general/gen031.svg"
                    alt="Filter Icon"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                    style={{ width: "20px", height: "20px" }} // force width/height if class fails
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-evenly"></div>
      </div>

      <div className="card-body pt-5" id="kt_chat_contacts_body">
        <Dropdown
          menuRef={filterDropdownMenuRef}
          droppedDown={filterMenuDroppedDown}
          setDroppedDown={setFilterMenuDroppedDown}
          width={250}
          hideOnBlur={false}
        >
          <form className="card-body px-10" onSubmit={handleFilter}>
            <div className="fw-bold align-items-center fs-4">Select Date</div>
            <br />
            <div className="mb-5 w-100">
              <label className="form-label" htmlFor="startDate">
                From
              </label>
              <input
                type="date"
                name="startDate"
                id="startDate"
                value={
                  models.chatFilters.startDate
                    ? new Date(models.chatFilters.startDate)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                min={new Date("2022-07-15").toISOString().split("T")[0]}
                max={
                  models.chatFilters.endDate
                    ? new Date(models.chatFilters.endDate)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                className="form-control"
                onChange={(e) => {
                  const newStartDate = e.target.value;
                  if (newStartDate.length > 0) {
                    operations.updateChatFilters("startDate", newStartDate);

                    // Adjust endDate if it's earlier than the new startDate
                    if (
                      models.chatFilters.endDate &&
                      new Date(newStartDate) >
                        new Date(models.chatFilters.endDate)
                    ) {
                      operations.updateChatFilters("endDate", "");
                    }
                  } else {
                    operations.updateChatFilters("startDate", undefined);
                  }
                }}
              />
            </div>
            <div className="mb-10 w-100">
              <label className="form-label" htmlFor="endDate">
                To
              </label>
              <input
                type="date"
                name="endDate"
                id="endDate"
                value={
                  models.chatFilters.endDate
                    ? new Date(models.chatFilters.endDate)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                min={
                  models.chatFilters.startDate
                    ? new Date(models.chatFilters.startDate)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                max={new Date().toISOString().split("T")[0]}
                className="form-control"
                onChange={(e) => {
                  console.log(e.target.value);
                  const newEndDate = e.target.value;
                  if (newEndDate.length > 0) {
                    operations.updateChatFilters("endDate", newEndDate);
                  } else {
                    operations.updateChatFilters("endDate", undefined);
                  }
                }}
              />
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="reset"
                className="btn btn-sm btn-white btn-active-light-primary me-2"
                onClick={() => setFilterMenuDroppedDown(false)}
              >
                Cancel
              </button>

              <button type="submit" className="btn btn-sm btn-primary">
                Apply
              </button>
            </div>
          </form>
        </Dropdown>
        <div className="scroll-y mh-550px">
          {state?.chatRooms?.length > 0 ? (
            state?.chatRooms?.map((chatRoom: any) => (
              <React.Fragment key={`unique-key-${uuidv4()}`}>
                <div className="d-flex flex-stack py-4">
                  <div className="d-flex align-items-center">
                    <div className="symbol symbol-45px symbol-circle">
                      {chatRoom.initials && (
                        <span
                          className={`symbol-label bg-light-${chatRoom.initials.state} text-${chatRoom.initials.state} fs-6 fw-bolder`}
                        >
                          {chatRoom.initials.label}
                        </span>
                      )}
                    </div>
                    <div className="ms-5">
                      <span
                        role="button"
                        onClick={() => handleChatRoomClick(chatRoom)}
                        className={`fs-5 fw-bolder text-hover-primary mb-2 ${
                          chatRoomID === chatRoom.id
                            ? "text-primary fw-bold"
                            : ""
                        }`}
                      >
                        {
                          // Match applicationId with data2.allApplicationId and show appName if matched
                          chatRoom.chatRoomMeta &&
                          chatRoom.chatRoomMeta.some((metaData: any) =>
                            metaData.name.toLowerCase().includes("name")
                          )
                            ? getDisplayName(chatRoom)
                            : data2?.allApplicationId?.find(
                                (app: any) =>
                                  parseInt(app.id) === chatRoom?.applicationId
                              )?.appName || "N/A"
                        }
                      </span>

                      <span
                        className="fw-bold text-muted"
                        style={{ marginLeft: "4.7rem" }}
                      >
                        {!!chatRoom?.chatName &&
                          formatEndDate(chatRoom?.chatName?.time)}
                      </span>
                      <div>
                        {!!chatRoom && (
                          <div className="d-flex flex-column">
                            <div className="fw-bold text-muted">
                              {`CONV-${getDisplayName(chatRoom)}`}{" "}
                              {/* Prefix with "CONV-" otherwise */}
                            </div>
                            {(chatRoom?.chatName?.agentId !== null ||
                              chatRoom?.assignedAgentId) && (
                              <div className="fw-bold text-muted">
                                AGENT-{getAgentName(chatRoom)}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="separator separator-dashed d-none" />
              </React.Fragment>
            ))
          ) : (
            <p className="text-center my-10">No Chatrooms to show</p>
          )}
        </div>

        <div className="card-footer p-3">
          <div className="row">
            <div className="d-flex align-items-center justify-content-center my-3">
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="kt_table_users_paginate"
              >
                <ul className="pagination">
                  <li
                    className={`paginate_button me-0 page-item ${isPrevDisabled}`}
                  >
                    <button
                      type="button"
                      aria-controls="kt_table_users"
                      data-dt-idx="0"
                      className="btn primary page-link"
                      onClick={prevPage}
                    >
                      <i className="previous"></i>
                    </button>
                  </li>
                  {paginationNumbers().map((pageNumber: any) => {
                    const isActive = currentPage === pageNumber ? "active" : "";
                    return (
                      <li
                        key={pageNumber}
                        className={`paginate_button page-item ${isActive}`}
                      >
                        <button
                          type="button"
                          aria-controls="kt_table_users"
                          data-dt-idx={pageNumber}
                          className="btn primary btn-sm page-link z-index-0"
                          onClick={() => paginate(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      </li>
                    );
                  })}
                  <li className={`paginate_button page-item ${isNextDisabled}`}>
                    <button
                      type="button"
                      aria-controls="kt_table_users"
                      data-dt-idx="0"
                      className="btn primary page-link"
                      onClick={nextPage}
                    >
                      <i className="next"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResolvedLeftPanel;
